export enum SiteIntegrationType {
  GENERIC = 'generic',
  DEALER_DOT_COM = 'ddc'
}

export interface SiteIntegrationInterfaceBase {
  type: SiteIntegrationType
  debug: boolean
}

export interface DealerDotComSiteIntegrationInterface
  extends SiteIntegrationInterfaceBase {
  type: SiteIntegrationType.DEALER_DOT_COM
  chat?: {
    buttonText: {
      en_US?: string
      es?: string
      fr_CA?: string
    }
    collectVehicleInfo: boolean
    hideEp: boolean
    useAgent: boolean
  }
}

export interface GenericSiteIntegrationInterface extends SiteIntegrationInterfaceBase {
  type: SiteIntegrationType.GENERIC
  javascript: string
}

export type SiteIntegrationInterface =
  | DealerDotComSiteIntegrationInterface
  | GenericSiteIntegrationInterface
